const React = require("react");
const T = React.PropTypes;
const Moment = require("moment");

require("./QuestionStatus.less");

const QuestionPropType = require("~/types/Question.js").PropType;

const QuestionUpdateError = require("../QuestionUpdateError/QuestionUpdateError.jsx");
const QuestionValidationMessages = require("../QuestionValidationMessages/QuestionValidationMessages.jsx");

const QuestionStatus = React.createClass({
    propTypes: {
        Question: QuestionPropType.isRequired,
        ShowLastChangedAt: T.bool // For debugging
    },
    render() {
        const error = this.GetUpdateError();
        const validationMessage = this.GetValidationMessage();

        return (<div className="cs-QuestionStatus">
            {validationMessage}
            {error}
        </div>);
    },
    GetUpdateError() {
        if (this.props.Question.UpdateError) {
            return (<QuestionUpdateError Error={this.props.Question.UpdateError } />);
        }

        return null;
    },
    GetValidationMessage() {
        if (this.props.Question.ValidationStatus) {
            if (!this.props.Question.ValidationStatus.IsValid
                && this.props.Question.ValidationStatus.Messages.length) {
                return (<QuestionValidationMessages Messages={this.props.Question.ValidationStatus.Messages } />);
            }
        }

        return null;
    }
});

module.exports = QuestionStatus;


// WEBPACK FOOTER //
// ./src/components/QuestionStatus/QuestionStatus.jsx